import { useEffect, useState } from 'react';
import { MdCall } from 'react-icons/md';
import { convertToSeconds } from '@/helper/formatTime';
import { TbAlertTriangleFilled } from 'react-icons/tb';

interface CallDurationProps {
  formattedDuration: string;
  callLimit: string;
  isPlaying: boolean;
}

export const CallDuration = ({ formattedDuration, callLimit, isPlaying }: CallDurationProps) => {
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    const duration = convertToSeconds(formattedDuration);
    const limit = convertToSeconds(callLimit);
    const remaining = limit - duration;

    setShowAlert(remaining > 0 && remaining <= 60);
  }, [formattedDuration, callLimit]);

  return (
    <div>
      <div
        className={`bg-[#66727e4d] flex py-2 items-center gap-2 px-3 pr-4 rounded-lg text-sm text-white font-light ${showAlert && 'animate-pulse bg-red-600/70'}`}
      >
        <span className="w-8 h-8 bg-buttonOrange rounded-full flex items-center justify-center">
          <MdCall size={18} />
        </span>
        <span className="flex flex-col items-start">
          <span className="font-semibold mr-2 ">Call Duration:</span>
          {formattedDuration}
        </span>
        <span className="flex flex-col items-start">
          <span className="font-semibold mr-2 "> Limit: </span>
          {callLimit}
        </span>
      </div>

      {isPlaying && showAlert && (
        <span className="text-xs text-red-400 font-semibold mt-2 ml-1 max-w-56 flex text-center">
          <TbAlertTriangleFilled size={18} className="mr-1" />
          Less than 1 minute remaining. Please wrap up your conversation.
        </span>
      )}
    </div>
  );
};
